import MalvernTyreAndService from './WorkshopsData/malverntyreandservice.data';
import RingwoodServiceCentre from './WorkshopsData/ringwoodServiceCentre.data';
import TyrePlusCaulfield from './WorkshopsData/tyreplusCaulfield.data';

const workshops = [MalvernTyreAndService, RingwoodServiceCentre, TyrePlusCaulfield];

export default workshops;
